export default __webpack_public_path__ + "static/media/ITR-7.0a38fbba.png";